// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "/* stylelint-disable-next-line selector-type-no-unknown */\n.ringIconDefaultColor_8df rg-icon,\n.ringIconDefaultColor_8df .ring-icon {\n  color: #999;\n  color: var(--ring-icon-secondary-color);\n}\n\n.iconMarginFix_2ae.iconMarginFix_2ae {\n  margin-right: 0;\n}\n\n.transcludeSpacer_c69:not(:empty) {\n  margin-left: 4px;\n}\n", ""]);
// Exports
exports.locals = {
	"ringIconDefaultColor": "ringIconDefaultColor_8df",
	"iconMarginFix": "iconMarginFix_2ae",
	"transcludeSpacer": "transcludeSpacer_c69"
};
module.exports = exports;
